module.exports = __webpack_public_path__ + "static/media/icon_warning_desc.86118b0b.svg";